import React from "react";
import { CircularProgress, Box } from "@mui/material";

const Loader = () => (
  <Box
    height="100vh"
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <CircularProgress />
  </Box>
);

export default Loader;
